import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import { categoriesSelector } from '../../../modules/selectors/standort/categories';

const COLLAPSE_CATEGORY_THRESHOLD = 30;

function countCategories(categories) {
    return categories.reduce(
        (total, category) =>
            total + 1 + (category.subCategories?.length ? countCategories(category.subCategories) : 0),
        0
    );
}

function CategorySearchMenu({ products, setFilterdProducts }) {
    const markenStandort = useSelector(markenStandortSelector)
    const categories = useSelector(categoriesSelector)
    //create category Map to track number of products in a category
    let categoryMap = new Map()
    products.forEach(product =>{
        if(!categoryMap.get(product?.categories[0])){
            categoryMap.set(product?.categories[0], 1)
        } else{
            categoryMap.set(product?.categories[0], categoryMap.get(product?.categories[0]) + 1)
        }
    })

    const filterCategories = (categories, categoryMap) => {
    return categories.map(category => {
            // Recursively filter subcategories first
            const filteredSubCategories = category.subCategories
                ? filterCategories(category.subCategories, categoryMap)
                : [];

            // Check if current category exists in the map
            const isValid = categoryMap.has(category.url);

            // Keep category if:
            // - it is valid
            // - OR it has valid subcategories
            if (isValid || filteredSubCategories.length > 0) {
                return {
                ...category,
                subCategories: filteredSubCategories
                };
            }

            // Otherwise remove it
            return null;
        })
        .filter(Boolean); // remove nulls
    };

    let filteredCategories = filterCategories(categories, categoryMap)

    const startCollapsed = useMemo(
        () => countCategories(filteredCategories) > COLLAPSE_CATEGORY_THRESHOLD,
        [filteredCategories]
    );

    const [selectedCategory, setSelectedCategory] = useState(null);

  // Helper: get all nested category IDs
    const getAllCategoryUrls = (category) => {
        let urls = [category.url];

        if (category.subCategories) {
        category.subCategories.forEach(sub => {
            urls = urls.concat(getAllCategoryUrls(sub));
        });
        }

        return urls;
    };


    useEffect(() => {
        if (!selectedCategory) return

        const validUrls = new Set(getAllCategoryUrls(selectedCategory));

        let filterdProducts = products.filter(product =>
        validUrls.has(product.categories[0])
        );

        setFilterdProducts(filterdProducts)
    }, [selectedCategory, products]);



    return(
        <div>
            {filteredCategories.map(category => 
                <CategoryItem
                    key={category.url}
                    category={category}
                    categoryMap={categoryMap}
                    onSelect={setSelectedCategory}
                    selectedCategory={selectedCategory}
                    startCollapsed={startCollapsed}
                />
            )}
        </div>
    )

        
}

const CategoryItem = ({ category, onSelect, selectedCategory, categoryMap, startCollapsed }) => {

    const [isOpen, setIsOpen] = useState(!startCollapsed);
    const panelId = `panel-for-${category.url}`

    const getCategoryCount = (category, categoryMap) => {
        // Count for current category
        const ownCount = categoryMap.get(category.url) || 0;

        // If no subcategories → just return own count
        if (!category.subCategories || category.subCategories.length === 0) {
            return ownCount;
        }

        // Otherwise sum all children recursively
        const subCount = category.subCategories.reduce((total, subCategory) => {
            return total + getCategoryCount(subCategory, categoryMap);
        }, 0);

        return ownCount + subCount;
    };

    const handleClick = (e) => {
        onSelect(category)
    };

    const handleToggle = () => {
        setIsOpen(prev => !prev);
    }

    const handlePress = (e) => {
        e.preventDefault()
        if(e.key == "Enter" || e.key == " " ){
            handleClick(e)
        }
    }

    const handleTogglePress = (e) => {
        e.preventDefault()
        if(e.key == "Enter" || e.key == " " ){
            handleToggle(e)
        }
    }

    return (
        <div style={{padding:"2px 0 0 0"}}>
            <div 
                style={{
                    cursor: "pointer",
                    fontWeight: selectedCategory?.url === category.url ? "bold" : "normal",
                    display: 'grid',
                    gridTemplateColumns: "auto 60px 25px",
                }}
            >
                <span 
                    style={{
                        fontWeight: category?.masterCategory ? 700 : 400,
                        color: selectedCategory?.url === category.url ? "var(--shop-main)" : 'unset',
                        wordBreak: 'break-word',
                    }}
                    onClick={handleClick}
                    onKeyPress={handlePress}
                    tabIndex={0}
                    aria-expanded={category?.subCategories.length > 0 ? isOpen : null}
                    role="button"
                    aria-controls={category?.subCategories.length > 0 ? panelId : null}
                >
                    {category?.title}
                </span> 
                <span style={{fontWeight: 400, width:55, textAlign: 'right', alignSelf:'center'}}>
                    ({getCategoryCount(category, categoryMap)}) 
                </span>
                {category?.subCategories.length > 0 ? 
                    <span 
                        aria-hidden="true" 
                        style={{justifySelf:"center", alignSelf:'center'}} 
                        uk-icon={isOpen ? "chevron-down" : "chevron-left"} 
                        onClick={handleToggle}
                        onKeyPress={handleTogglePress}
                        tabIndex={0}
                        aria-expanded={category?.subCategories.length > 0 ? isOpen : null}
                        role="button"
                        aria-controls={category?.subCategories.length > 0 ? panelId : null}
                    />
                : 
                    <span />
                }
            </div>
            {isOpen && category.subCategories?.length > 0 && (
            <div id={panelId} style={{ marginLeft: "12px" }}>
                {category.subCategories.map(sub => (
                    <CategoryItem
                    key={sub.id}
                    category={sub}
                    onSelect={onSelect}
                    selectedCategory={selectedCategory}
                    categoryMap={categoryMap}
                    startCollapsed={startCollapsed}
                    />
                ))}
            </div>
        )}
        </div>
    );
};

export default CategorySearchMenu;
